import React from 'react'
import PropTypes from 'prop-types'
import Select from '../../../form/component/Select'
import { renderStateName, renderTaskName } from '../../util/names'
import Authorization from '../../../security/component/auth/AuthorizationContainer'
import { ROLE_PROCESS_ADMIN } from '../../../security/state/auth/const'

const BeamProcessInstance = ({ beamProcessState, availableStateList, changeBeamProcessState, beamProcessInstance }) => {
    return (
        <Authorization requiredRole={ROLE_PROCESS_ADMIN}>
            <div className="beam-process">
                <div className="beam-process-select">
                    <Select object={beamProcessState}
                        name="beamProcessState"
                        valueList={availableStateList}
                        addEmpty={true}
                        renderer={(state) => {
                            const stateName = renderStateName(state.name)
                            return state.taskName === null ? stateName : stateName + ' <' + renderTaskName(state.taskName) + '>'
                        }}
                        onChange={changeBeamProcessState}/>
                </div>
                <div className="beam-process-button">
                    <button className="btn btn-danger btn-sm" onClick={beamProcessInstance}><i className="fa fa-magic"/> beam</button>
                </div>
            </div>
        </Authorization>
    )
}


BeamProcessInstance.propTypes = {
    beamProcessState: PropTypes.object.isRequired,
    availableStateList: PropTypes.array.isRequired,
    changeBeamProcessState: PropTypes.func.isRequired,
    beamProcessInstance: PropTypes.func.isRequired,
}

export default BeamProcessInstance



// WEBPACK FOOTER //
// ./src/modules/process/component/instance-detail/BeamProcessInstance.js